module.exports = __webpack_public_path__ + "img/week.5efa7998.png";